// import Auth from '../utils/Auth';
// import Notify from './../Common/Notify';
import { siteConfig, apisList } from '../variables/config';
import Security from './Security.services'
import { getToken, getObject, setObject } from './useful'
// const https = require('https');
// import https from 'https';
// import axios from 'axios';

// const instance = axios.create({
//     httpsAgent: new https.Agent({
//         rejectUnauthorized: false
//     })
// });
// const agent = new https.Agent({
//     rejectUnauthorized: false
// })

const requestSecurity = new Security()

class HttpService {


    request(action, params, cb) {
        let api = apisList[action]
        if (api) {
            this.checkParams(api, params, (newParams, paramsError) => {
                // console.log('errrrrrrrrrrrrrr',paramsError)

                if (!paramsError) {
                    // console.log('errrrrrrraaaarrrrrrr',newParams)

                    this.handleFiles(api, newParams, () => {
                        // console.log('aaaaaaaaaaaaa',api.route,newParams)

                        requestSecurity.hashData(newParams, api, (hashedData, hashError) => {
                            // console.log('tttttt',hashedData);
                            // console.log('tttttt',hashError);
                            if (!hashError) {
                                // console.log('--------------',hashedData)
                                fetch(siteConfig.domain + 'apiv2', this.serviceMethod(api, hashedData))
                                    .then(res => this.handleResponseError(res, (result, err, status) => {
                                        cb(result, err, status)
                                    })).catch(err => {
                                        // console.log('object', err);
                                        cb(null, err)
                                    })

                            } else {
                                cb(null, { error: "Security prevention" }) // TODO: Language
                            }
                        })
                    })
                } else {
                    cb(null, paramsError) // TODO: Language
                }
            })
        } else {
            cb(null, "Irrelevant request") // TODO: Language
        }
    }

    // request(action, params, cb) {
    //     let api = apisList[action]
    //     if (api) {
    //         this.checkParams(api, params, (newParams, paramsError) => {
    //             // console.log(paramsError)

    //             if (!paramsError) {
    //                 // console.log(newParams)

    //                 this.handleFiles(api, newParams, () => {

    //                     requestSecurity.notHashData(newParams, api, (hashedData, hashError) => {
    //                         if (!hashError) {
    //                             // console.log(hashedData)
    //                             fetch(this.makeUrl(siteConfig.domain + api.route, this.serviceMethod(api, hashedData).method, params), this.serviceMethod(api, hashedData))
    //                                 .then(res => this.handleResponseError(res, (result, err, status) => {
    //                                     cb(result, err, status)
    //                                 })).catch(err => {
    //                                     cb(null, err)
    //                                 })

    //                         } else {
    //                             cb(null, { error: "Security prevention" }) // TODO: Language
    //                         }
    //                     })
    //                 })
    //             } else {
    //                 cb(null, paramsError) // TODO: Language
    //             }
    //         })
    //     } else {
    //         cb(null, "Irrelevant request") // TODO: Language
    //     }
    // }

    makeUrl(url, method, params) {
        let myUrl = url
        // console.log(params)
        if (params && myUrl.includes('{{')) {
            for (const [key, value] of Object.entries(params)) {

                myUrl = myUrl.replace('{{' + key + '}}', value)
                // if (/\{\{(.*?)\}\}/.test(value)) {

                //     if (this.props.variables) {
                //         filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                //     }
                //     // console.log("VAR")
                // }
            }

            // if (method == "GET" && params && typeof params == 'string') {
            //     value = '/' + params
            // }
        }

        // console.log(myUrl)
        return myUrl
    }


    handleFiles(api, newParams, cb) {
        // console.log("handleFiles")
        // console.log(newParams['**files'])
        // console.log(JSON.parse(JSON.stringify(newParams)))
        if (!newParams['**files']) {
            cb()
            return
        }

        let files = newParams['**files']
        console.log('ffffffffffffffffffffffffff', files);
        this.uploadFiles(files, api, newParams, 0, () => {

            // Promise.all(promises).then(() => {
            delete newParams['**files']
            cb()
            // })
        })


    }



    uploadFiles(files, api, newParams, index, cb) {

        // let promises = []
        console.log(index)
        if (Object.entries(files) && Object.entries(files)[index]) {
            let [key, value] = Object.entries(files)[index]
            console.log(key)
            console.log(value)
            // promises.push(new Promise((resolve, reject) => {
            if (value) {
                this.fileUpload(value, newParams['applet'], key, (fileInfo) => {
                    console.log(fileInfo)
                    // let index = null
                    // if (key.includes('*')) {
                    //     console.log(key)
                    //     key = key.split('*')
                    //     index = key[1]
                    //     key = key[0]
                    //     console.log(key)
                    //     console.log(index)
                    // }
                    if (Array.isArray(fileInfo)) {
                        newParams[key] = Array.isArray(newParams[key]) ? newParams[key] : []
                        setObject(newParams, key, [...fileInfo], true)
                    } else {
                        setObject(newParams, key, fileInfo)
                    }
                    // resolve(fileInfo)
                    let pIndex = index + 1
                    this.uploadFiles(files, api, newParams, pIndex, cb)
                })
            }
            // }))

        } else {
            cb()
        }
        // console.log(newParams)

    }
    fileUpload(files, page, field, cb) {

        // console.log("UPLOAD")

        // allFiles.forEach((file, i) => {
        let filesInfo = []
        let allFiles = Array.isArray(files) ? files : [files]
        this.sendFileToServer(allFiles, filesInfo,Array.isArray(files) ?true:false, 0, page, field, (filesInfo) => {
            cb(filesInfo)
        })
        // if (file.formType === 'ImageInput') {
        //     fetchAddress = 'files/imageuploader'
        // }
        // if (file.formType === 'VideoInput') {
        //     fetchAddress = 'files/videouploader'
        // }

        // });

    }
    sendFileToServer(files, filesInfo,isArray, index, page, field, cb) {
        let file = files[index]
        if (file) {

            let fetchAddress = 'files/fileuploader'


            let count = 0


            // if (file) {
            let myFile = file
            if (myFile.file) {
                myFile = file.file
            }
            const req = new XMLHttpRequest();
            var formData = new FormData();


            formData.append('file', myFile);


            formData.append('field', field);
            formData.append('page', page);

            console.log(fetchAddress)
            req.open("POST", siteConfig.domain + fetchAddress, true);
            let parent = this

            req.upload.onprogress = function (e) {
                // console.log(e)
                let percentage = Math.floor((e.loaded / e.total) * 100)
                // let uploads = parent.state.uploads
                // uploads.forEach((upload, index) => {
                //     if (upload.key == field + i) {
                //         uploads[index].percentage = percentage
                //     }
                // });
                // parent.setState(uploads)
            }

            req.onload = function (e) {
                if (req.readyState === 4) {
                    // console.log(req)
                    if (req.status === 200) {
                        let data = JSON.parse(req.responseText);
                        // let data = this.handleResponseError(req.responseText)

                        if (!isArray) {
                            filesInfo = data.info
                            cb(filesInfo)
                        } else {
                            filesInfo.push(data.info)
                            let pIndex = index + 1
                          this.sendFileToServer(files, filesInfo,isArray, pIndex, page, field, cb)
                        }

                    } else {
                        cb(false)
                        console.error(req.statusText);
                    }
                }
            }.bind(this);
            req.onerror = function (e) {
                console.error(req.statusText);
            };

            req.send(formData);
            // } else {
            //     count = count + 1
            //     if (count === files.length) {
            //         cb(filesInfo)
            //     }
            // }

        } else {
            cb(filesInfo)

        }
    }


    // fileUpload(files, page, field, cb) {

    //     console.log("UPLOAD")
    //     let fetchAddress = 'values/uploader'

    //     let filesInfo = []
    //     let count = 0

    //     let allFiles = Array.isArray(files) ? files : [files]

    //     allFiles.forEach((file, i) => {

    //         // if (file.formType === 'ImageInput') {
    //         //     fetchAddress = 'files/imageuploader'
    //         // }
    //         // if (file.formType === 'VideoInput') {
    //         //     fetchAddress = 'files/videouploader'
    //         // }

    //         const req = new XMLHttpRequest();
    //         var formData = new FormData();

    //         if (file) {
    //             formData.append('images', file);
    //         }

    //         formData.append('field', field);
    //         formData.append('page', page);
    //         console.log(fetchAddress)

    //         req.open("POST", siteConfig.domain + fetchAddress, true);
    //         let parent = this

    //         req.upload.onprogress = function(e) {
    //             // console.log(e)
    //             let percentage = Math.floor((e.loaded / e.total) * 100)
    //                 // let uploads = parent.state.uploads
    //                 // uploads.forEach((upload, index) => {
    //                 //     if (upload.key == field + i) {
    //                 //         uploads[index].percentage = percentage
    //                 //     }
    //                 // });
    //                 // parent.setState(uploads)
    //         }

    //         req.onload = function(e) {
    //             if (req.readyState === 4) {
    //                 console.log(req)
    //                 if (req.status === 200) {
    //                     let data = JSON.parse(req.responseText);
    //                     // let data = this.handleResponseError(req.responseText)

    //                     if (!Array.isArray(files)) {
    //                         filesInfo = data.info
    //                         cb(filesInfo)
    //                     } else {
    //                         filesInfo.push(data.info)
    //                         count = count + 1
    //                         if (count === files.length) {
    //                             cb(filesInfo)
    //                         }
    //                     }

    //                 } else {
    //                     cb(false)
    //                     console.error(req.statusText);
    //                 }
    //             }
    //         }.bind(this);
    //         req.onerror = function(e) {
    //             console.error(req.statusText);
    //         };

    //         req.send(formData);

    //     });
    // }


    urlShaderrequest(action, params, cb) {
        let api = apisList[action]
        if (api) {
            this.checkParams(api, params, (chekcedParams, paramsError) => {
                // console.log("HERE")
                if (!paramsError) {
                    requestSecurity.notHashData(params, api, (hashedData, hashError) => {
                        if (!hashError) {
                            fetch(siteConfig.domain + '/apiv1', this.serviceMethod(api, hashedData))
                                .then(res => this.handleResponseError(res))
                                .then((data, err) => cb(data, err))
                                .catch(err => {
                                    // console.log('eEEE')
                                    cb(null, err)
                                })
                        } else {
                            cb(null, { error: "Security prevention" }) // TODO: Language
                        }
                    })
                } else {
                    cb(null, { error: paramsError }) // TODO: Language
                }
            })
        } else {
            cb(null, "Irrelevant request") // TODO: Language
        }
    }

    chooseServer() {
        // TODO :FUTURE
    }


    checkParams(api, params, cb) {
        let newParams = {}
        let errors = {}
        api.params.forEach(param => {
            newParams[param.key] = params[param.key]
            if (param.required) {
                if (params[param.key] == null && params[param.key] == '') {
                    // cb(null, {
                    errors[param.key] = '{{lang}}feildIsRequired'
                    // })

                }
                if (param.type && typeof params[param.key] != param.type) {

                    // cb(null, {
                    errors[param.key] = '{{lang}}invalidInputs'
                    // })
                }
            }
        });
        if (api.flexibleParams) {
            cb(params)
        } else {
            // console.log((errors != {}) ? errors : null)

            cb(newParams, errors.length ? errors : null)
        }
    }

    serviceMethod(api, data) {
        let request;
        const method = { method: api.method ? api.method.toUpperCase() : 'POST' }
        const Body = { body: JSON.stringify(data) }
        const AddProperty = {};
        const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json', "origin": 'localhost' }
        // The panel always acts in the Antbuildz realm; naming the host lets the API
        // scope identity lookups and reject storefront sessions here.
        if (typeof window !== 'undefined' && window.location?.host) {
            headers['X-Antbuildz-Realm-Host'] = window.location.host
        }

        if (api.auth === 'token') {
            let token = getToken()
            if (token) {
                headers.Authorization = "Bearer " + token
            } else {
                /// TO DO
            }
        }
        switch (method.method) {
            case 'GET':
                request = { ...method, headers, ...AddProperty }
                break;
            case 'POST':
                request = { ...method, headers, ...AddProperty, ...Body }
                break;
            case 'DELETE':
                request = { ...method, headers, ...AddProperty }
                break;
            case 'PUT':
                request = { ...method, headers, ...AddProperty, ...Body }
                break;
            default:
                break;
        }



        // const agent = new https.Agent({
        //     rejectUnauthorized: false
        // });


        // request.httpsAgent = agent //new https.Agent({ rejectUnauthorized: false }) //agent
        // request.rejectUnauthorized = false

        // request.rejectUnauthorized = false
        // request.requestCert = true
        // request.agent = false

        // request.httpsAgent = new https.Agent({
        //     rejectUnauthorized: false
        // })

        // request.host = siteConfig.domain + api.route
        // request.port = 443

        // console.log(request)


        return request
    }

    handleResponseError(res, cb) {
        const done = typeof cb === 'function' ? cb : () => {}
        res.json().then(result => {
            // console.log(res)
            if (!res.ok) {

                done(null, result, res.status)
                // return { result: null, err: result }
                // throw new Error("HTTP error, status = " + res.status);
            } else {
                // return { result }
                done(result, null, res.status)
            }
        }).catch(err => {
            console.log(err)
            done(null, err)
        })

    }

    async handlerResponseService(data) {
        // console.log('handlerResponseService', data);
        if (data && data.responseMessages) {
            for (let item of data.responseMessages) {
                // await Notify.notifycation({
                //     msg: `${item.name ? item.name + ': ' : ''} ${item.message}`,
                //     type: data.success ? 'success' : 'error',
                //     position: 'bottom-right'
                // })
            }
        }

        return data;
    }

    handleError(error) {
        console.log(error.message);
    }

}


export default new HttpService();